import { formatToCurrency } from "@/lib/utils";
import React from "react";

interface TotalExpensesCardProps {
  totalExpenses: number;
}

const TotalExpensesCard: React.FC<TotalExpensesCardProps> = ({
  totalExpenses,
}) => {
  return (
    <div className="bg-card p-4 rounded-lg shadow-sm text-center border border-border">
      <div className="flex items-center justify-center space-x-2">
        <span className="font-medium text-foreground">Total de Despesas</span>
      </div>
      <div className="text-2xl font-bold mt-3 text-primary bg-background rounded-lg p-2 text-foreground">
        {formatToCurrency(totalExpenses)}
      </div>
    </div>
  );
};

export default TotalExpensesCard;
